import styled from '@emotion/styled'
import { CheckCircle } from '@mui/icons-material'
import * as React from 'react'

import { Space, Typography } from '../../../../../../components/core-v2'

type ApprovalBoxProps = {
  children: React.ReactNode
  isApproved: boolean
  title: string
}

const MainBox = styled.div<{ isApproved: boolean }>`
  box-sizing: border-box;
  background-color: var(--White96);
`

const Header = styled.div<{ isApproved: boolean }>`
  background-color: ${props => (props.isApproved ? 'var(--Success)' : 'var(--White90)')};

  .icon {
    color: var(--White);
  }

  .title * {
    color: ${props => (props.isApproved ? 'var(--White)' : 'var(--Graphite)')};
  }
`

export const ApprovalBox = ({ children, isApproved, title }: ApprovalBoxProps) => (
  <MainBox isApproved={isApproved}>
    <Header isApproved={isApproved}>
      <Space isflex alignItems="center" justifyContent="space-between" px={5} py={4}>
        <div className="title">
          <Typography fontWeight="800" variant="b3">
            {title}
          </Typography>
        </div>
        <CheckCircle className="icon" />
      </Space>
    </Header>
    <Space px={5} py={6}>
      {children}
    </Space>
  </MainBox>
)
